'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _RotateLeftOutlined = _interopRequireDefault(require('./lib/icons/RotateLeftOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _RotateLeftOutlined;
exports.default = _default;
module.exports = _default;